import { render, staticRenderFns } from "./BaseShare.vue?vue&type=template&id=b05c9c12&scoped=true"
import script from "./BaseShare.vue?vue&type=script&lang=js"
export * from "./BaseShare.vue?vue&type=script&lang=js"
import style0 from "./BaseShare.vue?vue&type=style&index=0&id=b05c9c12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05c9c12",
  null
  
)

export default component.exports